<template>
    <v-container class="pa-0 ma-0" fluid flat style="width: 100%">

        <v-toolbar style="overflow:hidden" color="#FFA500" flat dense class="pb-0">
            <v-toolbar-items>
                <v-btn class="mx-0" text @click="setnavbar" color="black"><v-icon>menu</v-icon></v-btn>
                <div class="pa-1 mx-5 black--text menuhead" text tile>ALERTS</div>
                <v-menu class="pa-0 ma-0" style="position:absolute; left:45px; top:100px;" flat offset-y :key="this.$store.state.updatecount">
                    <template v-slot:activator="{ on }">
                        <v-btn :disabled="noAlerts" color="#FFA500" class="py-0 my-0" v-on="on"><v-icon color="black" class="pr-5 mr-0">filter</v-icon>{{filtertitle}}</v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in filteritems" :key="index" @click="setFilter(item)">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <v-menu class="pa-0 ma-0" style="position:absolute; left:255px; top:100px;" flat offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn :disabled="noAlerts" color="#FFA500" class="py-0 my-0" v-on="on"><v-icon color="black" class="pr-5 mr-0">sort</v-icon>{{sorttitle}}</v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="(item, index) in sortitems" :key="index" @click="setSort(item)">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar-items>
        </v-toolbar>

        <v-card flat color="#FFD375">
            <v-card class="pa-0 my-5" flat style="width: 600px" color="#FFD375" tile>
                <v-list two-line class="bckgrnd pa-0 ma-0" color="#FFD375" flat>
                    <v-content>
                        <v-list-item-group v-model="item" color="#FFD375">
                            <v-list-item color="#FFD375" v-for="(alert, i) in alerts" :key="i">
                                <v-row color="#FFD375" :class='rowClass(alert)' @click='rowClicked(alert)'>
                                    <v-col cols="7">
                                        <v-list-item-content>
                                            <v-list-item-title class="itemtext" v-text="alert.Name"></v-list-item-title>
                                            <v-list-item-subtitle class="unreadalerttext white--text" v-text="alertUnread(alert)"></v-list-item-subtitle>
                                            <v-list-item-subtitle class="totalalerttext black--text" v-text="alertTotal(alert)"></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="5" class="text-right">
                                        <v-container>
                                            <v-list-item-icon v-if="alert.IsSelected" class="px-2 py-0 ma-0" @click='deleteClicked(alert)'>
                                                <v-icon color="#000000">delete_forever</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-icon v-if="alert.IsSelected" class="pa-0 ma-0" @click='exploreClicked(alert)'>
                                                <v-icon color="#000000">explore</v-icon>
                                            </v-list-item-icon>
                                        </v-container>
                                    </v-col>
                                </v-row>
                            </v-list-item>
                        </v-list-item-group>
                    </v-content>
                </v-list>
            </v-card>
        </v-card>

    </v-container>
</template>

<script>
export default {
    mounted:function(){
        this.$store.state.heading = "Alerts";
        this.populateScreen(); 
        },
    data: () => ({
        sortitems: [
            { title: 'Latest first', prop: 'StartTime', dir: 'Down' },
            { title: 'Earliest first', prop: 'StartTime', dir: 'Up' }
        ],
        sorttitle: 'Sort...',
        filteritems: [
            { title: 'Show all' },
            { title: 'Show unread' },
        ],
        filtertitle: 'Show all',
        item: null,
        alerts: [],
        xparam: { title: 'Latest first', prop: 'StartTime', dir: 'Down' },
        selectedalert: null,
        selectedsurvey: null,
    }),
    methods: {
        setnavbar() {
            this.$store.state.navpage.setnavbar();
        },
        alertUnread(alert) {
            var str = "";
            if (alert.redcount>0)
                str += alert.redcount + " red ";
            if (alert.ambercount > 0)
                str += alert.ambercount + " amber ";
            if (alert.greencount > 0)
                str += alert.greencount + " green ";
            if (str.length > 0)
                str = "Unread: " + str;
            return str;
        },
        alertTotal(alert) {
            var str = "Total: ";
            str += alert.redtotal + " red ";
            str += alert.ambertotal + " amber ";
            str += alert.greentotal + " green ";
            return str;
        },
        exploreClicked(alert) {
            var thisthis = this;
            this.$store.state.surveys.forEach(survey => {
                if (survey.ID === alert.SurveyID) {
                    thisthis.selectedsurvey = survey;
                }
            });
            this.$store.state.exploresurvey = this.selectedsurvey;
            this.$store.state.selectedsurvey = this.selectedsurvey;
            var dbid = this.$store.state.databaseid;
            var uid = this.$store.state.user.uid;
            if (this.selectedsurvey.Remote) {
                dbid = this.selectedsurvey.DatabaseID;
                uid = this.selectedsurvey.CreatorID;
            }
            this.$store.dispatch('listenForSurveyData', { dbid: dbid, uid: uid });
            this.selectedsurvey.IsSelected = false;
            this.selectedsurvey = null;
            this.$store.state.selectedsurvey.IsSelected = false;
            this.$store.state.selectedsurvey = null;
            this.setSort(this.xparam);
            this.$store.state.heading = "Explore";
            this.$router.push({ path: 'explore' })
        },
        populateScreen() {
            this.alerts = this.$store.state.alerts;
            this.setSort(this.xparam);
        },
        meetsFilter(alert) {
            if (this.filtertitle === "Show all")
                return true;
            if (this.filtertitle === "Show unread") {
                var ur = alert.redcount + alert.greencount + alert.ambercount;
                if (ur > 0)
                    return true;
            }
            return false;
        },
        setFilter(param) {
            this.filtertitle = param.title;
            this.alerts = [];
            this.$store.state.alerts.forEach(alert => {
                if (this.meetsFilter(alert)) {
                    this.alerts.push(alert);
                }
            });
            this.setSort(this.xparam);
        },
        setSort(param) {
            try {
                this.sorttitle = "Sort by " + param.title;
                this.xparam = param;
                if (param.dir === 'Up')
                    this.alerts.sort((a, b) => a[this.xparam.prop] < b[this.xparam.prop] ? -1 : 1);
                else
                    this.alerts.sort((a, b) => a[this.xparam.prop] > b[this.xparam.prop] ? -1 : 1);
            }
            catch (e) {
                alert(e);
            }
        },
        rowClicked(alert) {
            if (this.selectedalert != null)
                this.selectedalert.IsSelected = false;
            alert.IsSelected = true;
            this.selectedalert = alert;
            this.$store.state.selectedalert = alert;
        },
        deleteClicked(alert) {
            this.$root.$confirm('Confirm', 'Are you sure you want to cancel alerts for this survey?', { color: '#FFA500' }).then((confirm) => {
                if (confirm) {
                    //this.$store.dispatch('cutAlert', this.selectedshare);
                }
            })
        },
        rowClass(alert) {
            if (alert.IsSelected)
                return 'selectedtile';
            else {
                return 'tile';
            }
        },
    },
    computed: {
        noAlerts() {
            if (!this.$store.state.alerts)
                return true;
            if (this.$store.state.alerts.length < 1)
                return true;
            else
                return false;
        },
        alertcount() {
            return this.$store.state.alerts.length;
        }
    },
    watch: {
        alertcount() {
            this.populateScreen();
        }
    }
}

</script>

<style>
    .tile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        border-color: black;
        background: #FFD375;
    }

        .tile:hover {
            background: #FFC733;
        }

    .selectedtile {
        margin: 0px;
        padding: 0px;
        border-radius: 0px;
        border-left-width: 0px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 1px;
        border-style: solid;
        background: #FFA500;
    }

    .menuhead {
        font-size: 1.5em;
        font-weight: bold;
    }

    .itemtext {
        font-size: 1.2em;
        font-weight: bold;
        color: #000000;
    }

    .unreadalerttext {
        font-size: 0.9em;
        font-weight: bold;
        color: #FFFFFF;
    }

    .totalalerttext {
        font-size: 0.9em;
        color: #000000;
    }
</style>
